import './css/bootstrap.min.css';
import './css/dataTables.bootstrap4.min.css';
import './App.css';
import { Component } from 'react';
import 'datatables.net'
import 'datatables.net-dt/css/jquery.dataTables.css'
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import Current_Issue from './current-issue'
import Ipo_Details from './ipo-details'

export default class App extends Component {
  
  render(){
    return (
      <div className="App">
        <BrowserRouter>
            <Routes>
              <Route exact path='/ipo-details' element={<Ipo_Details />}/>
              <Route exact path='/' element={<Current_Issue />}/>
            </Routes>
          </BrowserRouter>
      </div>
    );
  }
}
